var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 353.098,
    viewBox: "0 0 512 353.098",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bank-transfer-svgrepo-com",
    transform: "translate(0 -79.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54967",
    "data-name": "Path 54967",
    d: "M512,402.282a30.266,30.266,0,0,1-30.265,30.267H30.265A30.267,30.267,0,0,1,0,402.282V109.717A30.265,30.265,0,0,1,30.265,79.451H481.734A30.265,30.265,0,0,1,512,109.717V402.282Z",
    fill: "#e7e8e3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_974",
    "data-name": "Group 974"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54969",
    "data-name": "Path 54969",
    d: "M146.165,179.389h38.042c14.009-.227,29.384,3.418,29.384,20.389,0,7.289-4.329,13.211-10.706,16.4,8.654,2.505,14.011,10.024,14.011,19.249,0,19.363-14.239,25.284-31.665,25.284H146.165V179.389ZM167.348,211.4h16.4c3.643,0,8.654-1.937,8.654-7.745,0-5.923-4.215-7.858-8.654-7.858h-16.4v15.6Zm0,32.346H184.32c6.719,0,11.389-2.391,11.389-9.111,0-7.176-5.011-9.568-11.389-9.568H167.348Z",
    fill: "#006e90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54970",
    "data-name": "Path 54970",
    d: "M250.487,179.389h21.524l30.411,81.322h-22.1l-5.011-14.578h-28.36l-5.126,14.578H220.075Zm1.365,51.028H270.3l-9-28.474h-.226Z",
    fill: "#006e90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54971",
    "data-name": "Path 54971",
    d: "M308.336,179.389h21.757L358.339,229.5h.226V179.389H378.5v81.322H356.743L328.5,210.029h-.226v50.682H308.336Z",
    fill: "#006e90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54972",
    "data-name": "Path 54972",
    d: "M392.957,179.389h21.185V210.6l26.765-31.209h26.311L437.148,211.4l33.829,49.317H444.668L422.8,226.545l-8.656,9.112v25.056H392.958V179.39Z",
    fill: "#006e90"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_975",
    "data-name": "Group 975"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54973",
    "data-name": "Path 54973",
    d: "M92.893,290.217H76.184v43.452H61.6V290.217H44.891v-12.55h48Z",
    fill: "#66cde7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54974",
    "data-name": "Path 54974",
    d: "M99.324,277.668h28.55c9.883,0,19.608,4.472,19.608,15.764,0,6.04-2.9,11.766-8.783,14.042v.155c5.96,1.414,7.684,8.078,8.156,13.413.157,2.352.394,10.587,2.354,12.629H134.774c-1.254-1.882-1.489-7.373-1.646-8.941-.394-5.648-1.332-11.451-8.156-11.451H113.913v20.392H99.324Zm14.592,24.313h12.232c4.393,0,6.746-2.352,6.746-6.586,0-4.156-3.294-6.042-7.372-6.042H113.915S113.916,301.981,113.916,301.981Z",
    fill: "#66cde7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54975",
    "data-name": "Path 54975",
    d: "M171.169,277.668h14.824l20.941,56H191.716l-3.448-10.041H168.737l-3.528,10.041H150.226Zm.942,35.138h12.707l-6.2-19.611h-.157Z",
    fill: "#66cde7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54976",
    "data-name": "Path 54976",
    d: "M211.015,277.668h14.98l19.453,34.511h.159V277.668h13.726v56h-14.98l-19.455-34.9h-.157v34.9H211.015v-56Z",
    fill: "#66cde7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54977",
    "data-name": "Path 54977",
    d: "M280.665,314.845c.315,6.588,4.393,8.7,10.59,8.7,4.391,0,8.941-1.567,8.941-5.724,0-4.941-8-5.882-16.078-8.159-8-2.274-16.394-5.88-16.394-16.157,0-12.235,12.315-17.02,22.826-17.02,11.137,0,22.352,5.41,22.432,18.039H298.393c.235-5.1-4.55-6.745-9.021-6.745-3.137,0-7.059,1.1-7.059,4.785,0,4.313,8.078,5.1,16.235,7.373,8.081,2.274,16.237,6.038,16.237,16.156,0,14.2-12.08,18.748-24.393,18.748-12.863,0-24.234-5.649-24.316-20h14.589Z",
    fill: "#66cde7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54978",
    "data-name": "Path 54978",
    d: "M321.608,277.668h41.258v11.686H336.2v11.452h23.059V312.1H336.2V333.67H321.608Z",
    fill: "#66cde7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54979",
    "data-name": "Path 54979",
    d: "M369.535,277.668h44.629v11.686H384.123v9.8h27.452v11.294H384.123v10.668h30.826v12.548H369.536v-56Z",
    fill: "#66cde7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54980",
    "data-name": "Path 54980",
    d: "M423.263,277.668h28.55c9.883,0,19.606,4.472,19.606,15.764,0,6.04-2.9,11.766-8.783,14.042v.155c5.96,1.414,7.687,8.078,8.156,13.413.159,2.352.392,10.587,2.354,12.629H458.713c-1.257-1.882-1.489-7.373-1.647-8.941-.392-5.648-1.332-11.451-8.156-11.451H437.852v20.392H423.263v-56Zm14.589,24.313h12.237c4.391,0,6.742-2.352,6.742-6.586,0-4.156-3.291-6.042-7.372-6.042H437.852Z",
    fill: "#66cde7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_976",
    "data-name": "Group 976"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_773",
    "data-name": "Rectangle 773",
    width: 88.3,
    height: 17.682,
    transform: "translate(44.889 179.38)",
    fill: "#d92b2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_774",
    "data-name": "Rectangle 774",
    width: 88.3,
    height: 17.681,
    transform: "translate(44.889 243.03)",
    fill: "#d92b2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_775",
    "data-name": "Rectangle 775",
    width: 88.3,
    height: 17.682,
    transform: "translate(44.889 211.2)",
    fill: "#d92b2b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankTransfer);
export default __webpack_public_path__ + "static/media/bank-transfer.c1678e03536b1b66af274fb99c9b878c.svg";
export { ForwardRef as ReactComponent };